module.exports = __webpack_public_path__ + "img/flat-color-icons_google.3d3bb43b.svg";